import { Routes, Route } from 'react-router-dom';
import Capture from './Capture';

function App() {
  return (
    <Routes>
      <Route path="/s/:sessionId" element={<Capture />} />
    </Routes>
  );
}

export default App;
